import WayBillPage from './components/WayBillPage';

const routes = [
  {
    path: '/waybill',
    name: 'menu.waybill',
    icon: 'waybill',
    customIcon: true,
    loginRequired: true,
    component: WayBillPage,
    weight: 999,
    permission: [],
    children: [],
    forMobile: false,
  },
];

export default routes;
